import React from 'react';
import type { RedirectLoginOptions, User } from '@auth0/auth0-react';

export interface AppAuthShape {
  isAuthenticated: boolean;
  isLoading: boolean;
  user?: User;
  getAccessTokenSilently: (options?: {
    authorizationParams?: Record<string, string>;
  }) => Promise<string>;
  loginWithRedirect: (options?: RedirectLoginOptions) => Promise<void>;
  logout: (options?: { logoutParams?: { returnTo?: string } }) => Promise<void>;
}

export const AppAuthContext = React.createContext<AppAuthShape | null>(null);

export function useAppAuthContext(): AppAuthShape {
  const ctx = React.useContext(AppAuthContext);
  if (!ctx) {
    throw new Error(
      'AppAuthContext is not available. Wrap with Auth0Provider from src/auth'
    );
  }
  return ctx;
}
